"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var support_js_1 = require("./support.js");

var types_js_1 = require("./types.js");

var VoiceFocusInlineNode = /*#__PURE__*/function (_types_js_1$VoiceFocu) {
  _inherits(VoiceFocusInlineNode, _types_js_1$VoiceFocu);

  var _super = _createSuper(VoiceFocusInlineNode);

  function VoiceFocusInlineNode(context, options) {
    var _this;

    _classCallCheck(this, VoiceFocusInlineNode);

    _this = _super.call(this, context, options.processor, options);
    _this.channelCountMode = 'explicit';
    _this.channelCount = 1;
    var modelURL = options.modelURL,
        worker = options.worker,
        fetchBehavior = options.fetchBehavior,
        logger = options.logger,
        delegate = options.delegate;
    _this.logger = logger;
    _this.port.onmessage = _this.onProcessorMessage.bind(_assertThisInitialized(_this));
    _this.delegate = delegate;
    if (logger) logger.debug('VoiceFocusInlineNode:', modelURL);
    _this.worker = worker;
    _this.worker.onmessage = _this.onWorkerMessage.bind(_assertThisInitialized(_this));
    var message = support_js_1.supportsWASMPostMessage(globalThis) ? 'get-module' : 'get-module-buffer';

    _this.worker.postMessage({
      message: message,
      key: 'model',
      fetchBehavior: fetchBehavior,
      path: modelURL
    });

    return _this;
  }

  _createClass(VoiceFocusInlineNode, [{
    key: "onModuleBufferLoaded",
    value: function onModuleBufferLoaded(buffer, key) {
      this.port.postMessage({
        message: 'module-buffer',
        buffer: buffer,
        key: key
      });
    }
  }, {
    key: "onModuleLoaded",
    value: function onModuleLoaded(module, key) {
      this.port.postMessage({
        message: 'module',
        module: module,
        key: key
      });
    }
  }, {
    key: "enable",
    value: function enable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.port.postMessage({
                  message: 'enable'
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "disable",
    value: function disable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.port.postMessage({
                  message: 'disable'
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.port.postMessage({
                  message: 'stop'
                });
                this.disconnect();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "onProcessorMessage",
    value: function onProcessorMessage(event) {
      var _a, _b, _c;

      var data = event.data;

      switch (data.message) {
        case 'cpu':
          (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn('CPU warning:', data.message);
          (_b = this.delegate) === null || _b === void 0 ? void 0 : _b.onCPUWarning();
          break;

        default:
          (_c = this.logger) === null || _c === void 0 ? void 0 : _c.debug('Ignoring processor message.');
      }
    }
  }, {
    key: "onWorkerMessage",
    value: function onWorkerMessage(event) {
      var data = event.data;

      switch (data.message) {
        case 'module-buffer':
          if (!data.buffer || !data.key) {
            return;
          }

          this.onModuleBufferLoaded(data.buffer, data.key);
          break;

        case 'module':
          if (!data.module || !data.key) {
            return;
          }

          this.onModuleLoaded(data.module, data.key);
          break;

        case 'stopped':
          if (this.worker) {
            this.worker.terminate();
          }

          break;

        default:
          return;
      }
    }
  }]);

  return VoiceFocusInlineNode;
}(types_js_1.VoiceFocusAudioWorkletNode);

exports.default = VoiceFocusInlineNode;